import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import LowBrower from './lowBrower';
import Header from './header';
import Navigation from './navigation';
import Banner from './banner';
import NewsAndVideo from './newsAndVideo';
import FinanceAndPe from './financeAndPe';
import AutoAndEnt from './autoAndEnt';
import HistoryAndGame from './historyAndGame';
import HomeAndFood from './homeAndFood';
import PitAndBook from './pitAndBook';
import FashionAndTravel from './fashionAndTravel';
import TechAndGuoxue from './techAndGuoxue';
import DigitalAndFo from './digitalAndFo';
import FFHAndFiction from './ffhAndFiction';
import VipAndShop from './vipAndShop';
import Footer from './footer';
import QrCode from './qrCode';
import FloatAds from './floatAds';
import AddRed from './addRed';
import ChipView from './chipView';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        turnRed:
            this.props.content && this.props.content.topImg && this.props.content.topImg.isShow
                ? this.props.content.topImg.isShow
                : false,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        this.unHandleClick = addEventListener(document, 'click', this.handleClick);
    }

    componentWillUnmount() {
        this.unHandleClick();
    }

    handleCloseTurnRed = () => {
        this.setState({
            turnRed: false,
        });
    };

    // 全站渠道标记传递，文章页的任意跳转
    handleClick = e => {
        const tag = this.getATag(e.target);

        if (!tag) return;

        let localHref =
            (tag.attributes['sign-trs-href'] ? tag.attributes['sign-trs-href'].value : '') ||
            (tag.attributes['href'] ? tag.attributes['href'].value : '');

        if (
            localHref &&
            localHref !== 'undefined' &&
            localHref !== '' &&
            localHref !== '#' &&
            localHref.indexOf('javascript:') === -1
        ) {
            localHref = localHref.trim();
            const localSearch = location.search;
            const localHash = location.hash;

            tag.setAttribute('sign-trs-href', localHref);

            let newUrl = '';
            let inWhitelist = false;
            const whitelist = ['//dol.deliver.ifeng.com/'];

            for (let i = 0, len = whitelist.length; i < len; i++) {
                if (localHref.indexOf(whitelist[i]) > -1) {
                    inWhitelist = true;
                }
            }
            // 传递下划线开头的统计
            const curSrc = this.getParam(localSearch, localHash);

            if ((localSearch || localHash) && curSrc && !inWhitelist) {
                if (localHref.indexOf('?') > -1) {
                    newUrl = `${localHref}&${curSrc}`;
                } else {
                    newUrl = `${localHref}?${curSrc}`;
                }

                tag.setAttribute('href', newUrl);
            }
        }
    };

    getATag = tag => {
        if (!tag) {
            return null;
        }

        if (tag.tagName !== 'A') {
            return this.getATag(tag.parentElement);
        } else {
            return tag;
        }
    };

    getSign = (localSearch, ret) => {
        const localSearchArr = localSearch.split('#');

        for (let i = 0; i < localSearchArr.length; i++) {
            const localParam = localSearchArr[i];

            if (localParam.indexOf('_') === -1) continue;

            const localParamArr = localParam.split('?');

            for (let j = 0; j < localParamArr.length; j++) {
                const localParam2 = localParamArr[j];

                if (localParam2.indexOf('_') === -1) continue;

                const localParam2Arr = localParam2.split('&');

                for (let m = 0; m < localParam2Arr.length; m++) {
                    const localParam3 = localParam2Arr[m];

                    if (localParam3.indexOf('_') === -1) continue;

                    const localParam3Arr = localParam3.split('|');

                    for (let k = 0; k < localParam3Arr.length; k++) {
                        const localParam4 = localParam3Arr[k];

                        if (localParam4.indexOf('_') !== 0) continue;

                        if (ret === '') {
                            ret += localParam4;
                        } else {
                            ret = `${ret}&${localParam4}`;
                        }
                    }
                }
            }
        }

        return ret;
    };

    getParam = (localSearch, localHash) => {
        let ret = '';

        if (localSearch.indexOf('_zbs') > -1) {
            ret = this.getSign(localSearch, ret);
        }
        if (localHash.indexOf('_zbs') > -1) {
            ret = this.getSign(localHash, ret);
        }

        return ret;
    };

    render() {
        const { turnRed } = this.state;
        const { content } = this.props;

        const redConfig = {
            isIpad: content.isIpad ? content.isIpad : false,
            topImg: content.topImg ? content.topImg : {},
        };

        const headerData = {
            logo: content.logo,
            danate: content.donate,
            search: content.search,
            jubaoData: content.jubaoData,
        };

        const navigationData = {
            nav: content.navigation,
            subNav: content.subNavigation,
            subNavArea: content.subNavArea,
        };

        const bannerData = {
            content: content.recommendImage,
            bannerAd: content.bannerAd,
        };

        const newsAndVideoData = {
            newsSiderData: {
                newsSiderTitle0: content.newsSiderTitle0,
                newsSiderContent0: content.newsSiderContent0,
                newsSiderContent1: content.newsSiderContent1,
                newsSiderContent2: content.newsSiderContent2,
                newsSiderContent3: content.newsSiderContent3,
                newsSiderContentList: content.newsSiderContentList,
                newsSiderAd: content.newsSiderAd,
                ipadAd0: content.ipadAd0,
            },
            newsData: {
                newsBoxData: {
                    newsTopData: {
                        newsTitle: content.newsTitle,
                        newsTitleAd: content.newsTitleAd,
                        newContent: {
                            newsContent0: content.newsContent0,
                            newsContent1: content.newsContent1,
                            newsContent2: content.newsContent2,
                            newsContent3: content.newsContent3,
                        },
                        newsListAd: content.newsListAd,
                    },
                    liveAd: content.liveAd,
                },
                slideData: {
                    slidesTab: content.slidesTab,
                    slideContent: {
                        slidesNews: content.slidesNews,
                        slidesEnt: content.slidesEnt,
                        slidesSport: content.slidesSport,
                        slidesAuto: content.slidesAuto,
                        slidesFashion: content.slidesFashion,
                        slidesMil: content.slidesMil,
                        slidesHouse: content.slidesHouse,
                        slidesVideo: content.slidesVideo,
                    },
                },
                videoBoxData: {
                    videoTitle: content.videoTitle,
                    videoContent0: content.videoContent0,
                    videoContent1: content.videoContent1,
                    videoContent2: content.videoContent2,
                    videoWSContent: content.videoWSContent,
                    videoJSContent: content.videoJSContent,
                    videoLSContent: content.videoLSContent,
                    videoWHContent: content.videoWHContent,
                    videoCJContent: content.videoCJContent,
                    videoKJContent: content.videoKJContent,
                    videoPEContent: content.videoPEContent,
                    videoFFHContent: content.videoFFHContent,
                    videoGGContent: content.videoGGContent,
                    videoListAd: content.videoListAd,
                },
                newsAndVideoAd0: content.newsAndVideoAd0,
                newsAndVideoAd1: content.newsAndVideoAd1,
                newsAndVideoAd2: content.newsAndVideoAd2,
            },
        };

        const financeAndPeData = {
            fpNewsSiderData: {
                fpNewsSiderTitle: content.fpNewsSiderTitle,
                fpNewsSiderStockImg: content.fpNewsSiderStockImg,
                fpNewsSiderStockSearch: content.fpNewsSiderStockSearch,
                fpNewsSiderList: content.fpNewsSiderList,
                fpNewsSiderContent: content.fpNewsSiderContent,
            },
            fpNewsData: {
                financeData: {
                    financeTopic: content.financeTopic,
                    financeTitle0: content.financeTitle0,
                    financeTitle1: content.financeTitle1,
                    financeList0: content.financeList0,
                    financeList1: content.financeList1,
                    financeList2: content.financeList2,
                    financeList3: content.financeList3,
                    financeListAd: content.financeListAd,
                },
                peData: {
                    peTopic: content.peTopic,
                    peTitle: content.peTitle,
                    peContent0: content.peContent0,
                    peContent1: content.peContent1,
                    peListAd: content.peListAd,
                },
                financeAndPeAd: content.financeAndPeAd,
            },
        };

        const autoAndEntData = {
            aeNewsSiderData: {
                aeNewsSiderTitle: content.aeNewsSiderTitle,
                aeNewsSiderContent0: content.aeNewsSiderContent0,
                aeNewsSiderContent1: content.aeNewsSiderContent1,
                aeNewsSiderContent2: content.aeNewsSiderContent2,
                autoAndEntSiderAd: content.autoAndEntSiderAd,
                ipadAd1: content.ipadAd1,
            },
            aeNewsData: {
                autoData: {
                    autoTopic: content.autoTopic,
                    autoTitle0: content.autoTitle0,
                    autoTitle1: content.autoTitle1,
                    autoList0: content.autoList0,
                    autoList1: content.autoList1,
                    autoList2: content.autoList2,
                    autoListAd: content.autoListAd,
                },
                entData: {
                    entTopic: content.entTopic,
                    entTitle: content.entTitle,
                    entList: content.entList,
                    entBoxData: content.entBoxData,
                    entVideoList: content.entVideoList,
                    entVideoBoxData: content.entVideoBoxData,
                    entListAd: content.entListAd,
                },
                autoAndEntAd0: content.autoAndEntAd0,
                autoAndEntAd1: content.autoAndEntAd1,
                autoAndEntAd2: content.autoAndEntAd2,
            },
        };

        const historyAndGameData = {
            hgNewsSiderData: {
                hgNewsSiderTitle: content.hgNewsSiderTitle,
                hgNewsSiderContent: content.hgNewsSiderContent,
                hgNewsSiderTabs: content.hgNewsSiderTabs,
            },
            hgNewsData: {
                historyData: {
                    historyTopic: content.historyTopic,
                    historyTitle: content.historyTitle,
                    historyList0: content.historyList0,
                    historyList1: content.historyList1,
                    historyList2: content.historyList2,
                },
                gameData: {
                    gameTopic: content.gameTopic,
                    gameTitle: content.gameTitle,
                    gameList0: content.gameList0,
                    gameList1: content.gameList1,
                    gameList2: content.gameList2,
                },
            },
        };

        const homeAndFoodData = {
            houseAreaMap: content.houseAreaMap,
            hfNewsSiderData: {
                pfNewsSiderAd: content.pfNewsSiderAd,
                ipadAd2: content.ipadAd2,
            },
            hfNewsData: {
                homeData: {
                    homeTopic: content.homeTopic,
                    homeTitle0: content.homeTitle0,
                    homeTitle1: content.homeTitle1,
                    homeList0: content.homeList0,
                    homeList1: content.homeList1,
                    homeList2: content.homeList2,
                },
                foodData: {
                    foodTopic: content.foodTopic,
                    foodTitle: content.foodTitle,
                    foodList0: content.foodList0,
                    foodList1: content.foodList1,
                },
                pitAndFoodAd: content.pitAndFoodAd,
            },
        };

        const pitAndBookData = {
            pbNewsSiderData: {
                pbNewsSiderContent: content.pbNewsSiderContent,
                hbNewsSiderAd: content.hbNewsSiderAd,
                ipadAd3: content.ipadAd3,
            },
            pbNewsData: {
                pitData: {
                    pitTopic: content.pitTopic,
                    pitTitle0: content.pitTitle0,
                    pitTitle1: content.pitTitle1,
                    pitList0: content.pitList0,
                    pitList1: content.pitList1,
                },
                bookData: {
                    bookTopic: content.bookTopic,
                    bookTitle: content.bookTitle,
                    bookList0: content.bookList0,
                    bookList1: content.bookList1,
                },
                homeAndBookAd0: content.homeAndBookAd0,
                homeAndBookAd1: content.homeAndBookAd1,
                homeAndBookAd2: content.homeAndBookAd2,
            },
        };

        const fashionAndTravelData = {
            ftNewsSiderData: {
                ftNewsSiderContent: content.ftNewsSiderContent,
                ftNewsSiderAd: content.ftNewsSiderAd,
                ipadAd4: content.ipadAd4,
            },
            ftNewsData: {
                fashionData: {
                    fashionTopic: content.fashionTopic,
                    fashionTitle: content.fashionTitle,
                    fashionList: content.fashionList,
                    fashionBoxData: content.fashionBoxData,
                    fashionListAd: content.fashionListAd,
                },
                travelData: {
                    travelTopic: content.travelTopic,
                    travelTitle: content.travelTitle,
                    travelList0: content.travelList0,
                    travelList1: content.travelList1,
                },
                fashionAndTravelAd: content.fashionAndTravelAd,
            },
        };

        const techAndGuoxueData = {
            tgNewsSiderData: {
                tgNewsSiderContent: content.tgNewsSiderContent,
                tgNewsSiderAd: content.tgNewsSiderAd,
                ipadAd5: content.ipadAd5,
            },
            tgNewsData: {
                techData: {
                    techTopic: content.techTopic,
                    techTitle0: content.techTitle0,
                    techTitle1: content.techTitle1,
                    techList0: content.techList0,
                    techList1: content.techList1,
                    techList2: content.techList2,
                    techListAd: content.techListAd,
                },
                guoxueData: {
                    guoxueTopic: content.guoxueTopic,
                    guoxueTitle: content.guoxueTitle,
                    guoxueList0: content.guoxueList0,
                    jiaoyuList: content.jiaoyuList,
                    guoxueList1: content.guoxueList1,
                },
                techAndGuoxueAd0: content.techAndGuoxueAd0,
                techAndGuoxueAd1: content.techAndGuoxueAd1,
            },
        };

        const digitalAndFoData = {
            dfNewsSiderData: {
                dfNewsSiderAd: content.dfNewsSiderAd,
                ipadAd6: content.ipadAd6,
            },
            dfNewsData: {
                digitalData: {
                    digitalTopic: content.digitalTopic,
                    digitalTitle: content.digitalTitle,
                    digitalList0: content.digitalList0,
                    digitalList1: content.digitalList1,
                },
                foData: {
                    foTopic: content.foTopic,
                    foTitle: content.foTitle,
                    foList0: content.foList0,
                    foList1: content.foList1,
                },
                digitalAndFoAd: content.digitalAndFoAd,
            },
        };

        const ffhAndFictionData = {
            ffNewsSiderData: {
                ffNewsSiderContent: content.ffNewsSiderContent,
                ffNewsSiderTabs: content.ffNewsSiderTabs,
                ffNewsSiderAd: content.ftNewsSiderAd,
            },
            ffNewsData: {
                ffhData: {
                    ffhTopic: content.ffhTopic,
                    ffhTitle: content.ffhTitle,
                    ffhList: content.ffhList,
                    ffhBoxData: content.ffhBoxData,
                },
                fictionData: {
                    fictionTopic: content.fictionTopic,
                    fictionTitle: content.fictionTitle,
                    fictionList0: content.fictionList0,
                    fictionList1: content.fictionList1,
                },
            },
        };

        const vipAndShopData = {
            vsNewsSiderData: {
                vsNewsSiderTitle: content.vsNewsSiderTitle,
                vsNewsSiderTips: content.vsNewsSiderTips,
                vsNewsSiderContent0: content.vsNewsSiderContent0,
                vsNewsSiderContent1: content.vsNewsSiderContent1,
            },
            vsNewsData: {
                vipData: {
                    vipTopic: content.vipTopic,
                    vipTitle: content.vipTitle,
                    vipList0: content.vipList0,
                    vipList1: content.vipList1,
                    vipList2: content.vipList2,
                    vipBoxData0: content.vipBoxData0,
                    vipBoxData1: content.vipBoxData1,
                },
                shopData: {
                    shopTopic: content.shopTopic,
                    shopTitle: content.shopTitle,
                    shopList0: content.shopList0,
                    shopList1: content.shopList1,
                },
            },
        };

        const qrCodeData = {
            qrCode: content.qrCode,
        };

        const floatAds = {
            floatAd1: content.floatAd1,
            floatAd2: content.floatAd2,
            floatAd3: content.floatAd3,
            floatAd4: content.floatAd4,
            floatAd5: content.floatAd5,
            floatAd6: content.floatAd6,
            floatAd7: content.floatAd7,
        };

        return (
            <div className={redConfig.isIpad ? styles.ipad_layout : styles.layout}>
                <NoSSR>
                    <LowBrower content={content.lowOptions} devicetype={content.devicetype} />
                </NoSSR>
                <NoSSR>
                    <Chip
                        id="50128"
                        type="struct"
                        title="页面飘红配置"
                        groupName="页面飘红配置"
                        content={redConfig.topImg}>
                        <AddRed
                            isIpad={redConfig.isIpad}
                            turnRed={turnRed}
                            handleCloseTurnRed={this.handleCloseTurnRed}
                        />
                    </Chip>
                </NoSSR>
                <Header content={headerData} />
                <Navigation content={navigationData} turnRed={turnRed} />
                <div>
                    <NoSSR>
                        {content.topAd0 ? <Ad content={content.topAd0} styleName={`${styles.topAd0} topAd0`} /> : ''}
                        {content.topAd1 ? <Ad content={content.topAd1} /> : ''}
                    </NoSSR>
                </div>
                <Banner content={bannerData} />
                <NewsAndVideo content={newsAndVideoData} />
                <FinanceAndPe content={financeAndPeData} />
                <AutoAndEnt content={autoAndEntData} />
                <HistoryAndGame content={historyAndGameData} />
                <HomeAndFood content={homeAndFoodData} />
                <PitAndBook content={pitAndBookData} />
                <FashionAndTravel content={fashionAndTravelData} />
                <TechAndGuoxue content={techAndGuoxueData} />
                <DigitalAndFo content={digitalAndFoData} />
                <FFHAndFiction content={ffhAndFictionData} />
                <VipAndShop content={vipAndShopData} />
                {content.bottomAd1 ? <Ad content={content.bottomAd1} styleName={styles.bottomAd1} /> : ''}
                <NoSSR>
                    <Chip id="40008" type="static" title="底部版权" groupName="底部" content={content.footer}>
                        <Footer />
                    </Chip>
                    <Chip id="50109" type="struct" title="二维码" groupName="二维码" content={qrCodeData}>
                        <QrCode />
                    </Chip>
                    <FloatAds content={floatAds} />
                    <ChipView />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
